/** In-app Record Reviewer Work Queue (static Figma prototype). */
export const REVIEWER_WORKFLOW_ROUTE = '/reviewer-workflow';

/** Inner task workspace so FormEngine can return to the same Reviewer Work Queue page. */
export const REVIEWER_WORKFLOW_TASK_QUERY = 'task';

/** Catalog / queue row id prefix: flowable-{examineeProfileId}-{caseId}-{examId}. */
export const REVIEWER_FLOWABLE_CATALOG_TASK_ID_PREFIX = 'flowable-';

/** Static testKey for dashboard card → Reviewer Work Queue. */
export const REVIEWER_WORKFLOW_TEST_KEY = 'record_review';

/** Primary MEF handoff label on the Record Reviewer task workspace. */
export const REVIEWER_OPEN_PART_B_MEF_LABEL = 'Open Part B in MEF';

/** Right-pane action card heading on the Record Reviewer task workspace. */
export const REVIEWER_ACTION_SECTION_LABEL = 'Reviewer Action';
